import React from 'react';
import { TwainGameId } from 'betgames-contract-js';
import { camelCase } from 'lodash-es';
import classNames from 'classnames';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { EMPTY_SPACE } from 'twain-sport-fe-mono/constants/textSymbols';
import { TableTooltip } from '../TableTooltip';
import classes from './ParticipantsTable.module.scss';

export interface IStatisticsColumn {
    name: string;
    shortName: string;
}

interface IProps {
    firstColumnText: string;
    statisticsColumns: IStatisticsColumn[];
    className?: string;
    gameId?: TwainGameId;
}

export const ParticipantsTable: React.FC<React.PropsWithChildren<IProps>> = (props) => (
    <table className={classNames(classes.table, props.className)}>
        <thead>
            <tr>
                <th
                    colSpan={3}
                    className={classes.textLeft}
                    data-qa="block-participants-statistic-first"
                >
                    <span data-qa="title-participants-statistic-first">
                        {props.firstColumnText}
                    </span>
                </th>
                {props.statisticsColumns.map((value) => (
                    <th
                        key={value.name}
                        data-qa={`block-participants-statistic-${camelCase(value.name)}`}
                    >
                        <TableTooltip
                            tooltipText={translationProvider.stringByGame(value.name, props.gameId)}
                        >
                            <span data-qa={`title-participants-statistic-${camelCase(value.name)}`}>
                                {translationProvider.string(value.shortName)}
                            </span>
                        </TableTooltip>
                    </th>
                ))}
                <th>{EMPTY_SPACE}</th>
            </tr>
        </thead>
        <tbody>{props.children}</tbody>
    </table>
);
